export default __webpack_public_path__ + "1e1ff53c3f6582eb6ea6ccb641fe6051.png";